<template>
  <div>
    <div class="time themes_menu_wrap_1">
      <p>比赛倒计时</p>
      <XDcountdown></XDcountdown>
    </div>
    <!-- 立即报名 -->
    <div class="sign">
      <!-- <span @click="gotopath('/'+gameId+'/sign')">立即报名</span> -->
      <span @click="show" style="cursor:pointer">立即报名</span>
    </div>
    <!-- 比赛日程 -->
    <div class="match-info themes_partner_name_1">
      <div class="news_title" style="width:80%;">
        <span
          class="themes_menu_wrap_1"
          style="display: inline-block;width: 5px;margin-top:5px;height: 35px;margin-bottom:-5px;"
        ></span>
        赛事地点
      </div>

      <div class="match-info-content">
        <div class="xcxQR-wrap" id="map" style="height:100%;min-height:300px;">
          <!-- 暂代日程图 -->
          <!-- <a :href="gotoMap()"  target="_blank"><img src="../assets/img/map.png" alt="" style="width:100%;"></a> -->
        </div>
      </div>
    </div>
    <div id="code" style="display:none;" >
      <img :src="this.match.xcxurl" id="qs" style="width:100%;" alt />
      <i
        class="el-icon-close"
        @click="hide"
        style="font-size:28px;position :absolute;right:15px;top:10px;cursor:pointer"
      ></i>
      <p style="text-align:center;font-size:16px;width:100%;">扫描上方二维码，进入报名</p>
    </div>
  </div>
</template>

<script>
import api from "@/axios";
import { mapState, mapGetters } from "vuex";
export default {
  name: "right",
  data() {
    return {};
  },
  mounted() {
    $(".time span").css({ "font-size": "2em", margin: 0 });
    console.log(this.match);

    this.showMap(this.match);
  },
  methods: {
    gotopath(path) {
      this.$router.push({ path });
    },
    gotoMap() {
      return `https://uri.amap.com/marker?name=${this.match.name}&&position=${this.match.longitude},${this.match.latitude}`;
    },
    showMap(coords) {
      var myLatAndLong = new qq.maps.LatLng(coords.latitude, coords.longitude);
      var map = $("#map");
      map = new qq.maps.Map(document.getElementById("map"), {
        center: myLatAndLong,
        zoom: 13,
        draggable: true,
        scrollwheel: true,
        disableDoubleClickZoom: false,
        disableDefaultUI: true
      });
	},
	  show() {
      $("#code").css("display", "block");
	},
	hide(){
		 $("#code").css("display", "none");
	}
  },
  computed: {
    ...mapState(["appweb", "gameId", "match"])
  }
};
</script>
<style scoped>
.time {
  text-align: center;
  box-shadow: none;
  padding-bottom: 10px;
  margin-bottom: 30px;
}
p {
  padding: 10px 0;
  margin: 0 auto 10px;
  width: 50%;
  font-size: 20px;
  border-bottom: 1px solid #fff;
}
.sign {
  background: #ebebeb;
  border-radius: 5px;
  height: 80px;
  text-align: center;
  margin-bottom: 30px;
}
span {
  box-shadow: none;
}
.sign span {
  background: #f47920;
  color: #fff;
  padding: 10px 20px;
  line-height: 80px;
  font-size: 18px;
}
.news_title {
  font-size: 26px;
  border-bottom: 1px solid #1b6ce1;
  margin-bottom: 20px;
}
/* 日程图片 */
.xcxQR-wrap {
  width: 100%;
  padding: 20px;
  background-color: #ebebeb;
  border-radius: 5px;
  margin-bottom: 100px;
}
img {
  width: 100%;
}
#code {
  width: 400px;
  height: 400px;
  position: fixed;
  left: 50%;
  top: 20%;
  transform: translate(-50%);
  /* background-color: rgba(255,255,255,.9); */
  background: #fff;
  z-index: 999;
  padding: 30px;
  padding-top: 15px;
}
</style>



// WEBPACK FOOTER //
// src/components/xd-right.vue